<template>
    <div>
        <div class="mb-4"></div>

        <div class="product-intro row row-md">
            <LoadingApp
                :is_full_page="true"
                :isLoading="isLoading"
            />
            <template v-if="itemsWishlist.length">
                <template v-for="item in itemsWishlist">
                    <Product
                        :isSharedWishlist="true"
                        :key="item.id"
                        :pro="item"
                        layout_mode="list"
                        :page_wish_list="true"
                        :products_settings="products_settings"
                        @updateList="updateList"
                    
                    >
                    </Product>
                    
                </template>
            </template>
            <template v-else>
                <div
                    class="col-md-12"
                    style="display:flex; align-items:center;justify-content:center"
                >
                    <h3 style="color:#DB1;">
                        Esta lista de desejos está vazia
                    </h3>
                </div>
            </template>
        </div>

        <Pagination
            :source="pagination"
            @navigate="navigate"
            :pagination_range="6"
        />
    </div>
</template>

<script>
import { CPrimaryTitle } from "../../components/Styles/Components/styled";
import { mapActions, mapState } from 'vuex';
import Pagination from '../../components/Pagination.vue'
import LoadingApp from '../../components/LoadingApp.vue'
import { CButton } from '../../components/Styles/Button/styled';
import { swall } from '../../services/sweetAlert'
import Product from "./Product.vue";

export default {
    name: "Wishlistshare",
    props: {
        // products_settings: {
        //     default: null,
        //     required: true,
        // },
        id: {
            default: null,
            required: true
        }
    },
    components: {
        'c-button': CButton,
        Product,
        Pagination,
        LoadingApp,
        'primary-title': CPrimaryTitle
    },
    data() {
        return {
            isLoading: false,
            page: 1,
        }
    },
    mounted() {
        this.getList()
    },
    methods: {
        ...mapActions("wishlist", [
            "getListPaginate",
            "setItemsWishlist",
            "setPagination",
            "ActionRemoveAllItemsWishList",
            "getListPaginateByUser"
            
        ]),

        navigate(page = this.page) {
            this.page = page
            this.getList()
            let titleWishlist = document.querySelector('#title-wishlist')
            let sectionTitleWishlist = titleWishlist.getBoundingClientRect()
            window.scroll(0, sectionTitleWishlist.top + scrollY - titleWishlist.offsetHeight)
        },
        getList() {
            this.isLoading = true
            const payload  = {
                filters: this.getFilters(),
                userId: this.id
            }

            this.getListPaginateByUser(payload)
            .then(response => {
                
                this.isLoading = false
                this.setItemsWishlist(response.data.data)

                this.setPagination(response.data)
            })
            .catch(error => {
                this.isLoading = false
                console.log(error)
            })
        },
        getFilters() {
            return {
                page: this.page
            }
        },
        updateList() {
            if(this.itemsWishlist.length == 1 && this.page > 1) {
                this.page--
            }
            this.getList()
        },
    },
    computed: {
        ...mapState("wishlist", [
            "itemsWishlist",
            "pagination",
        ]),
        
        products_settings() {
            return this.$root.$children[0].$attrs.company?.products_settings ?? null
        }
    }
};
</script>